export const dateValueFormat = 'YYYY-MM-DD';
export const dateTimeValueFormat = 'YYYY-MM-DDTHH:mm:ss';
export const dateDisplayFormat = 'MMM dd, yyyy';
export const momentDateDisplayFormat = 'MMM DD, YYYY';
export const momentDateTimeDisplayFormat = 'MMM DD, YYYY HH:mm';
export const timeDisplayFormat = 'HH:mm';
